webpackJsonp([26],{

/***/ "/69k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bloquearCamposFormulario;
/* harmony export (immutable) */ __webpack_exports__["b"] = fecharModal;
function bloquearCamposFormulario() {
  $("select, input[type=date],input[type=checkbox], input, textarea, file").prop('disabled', true);
  $(".k-select, .k-clear-value").hide();
}

function fecharModal() {

  $("body").on('click', '.fechar-modal', function () {
    $(this).closest('.modal').modal('close');
  });
}

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "2d5O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4+hh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HPt6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "L773":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-material/dist/vue-material.js
var vue_material = __webpack_require__("Lgyv");
var vue_material_default = /*#__PURE__*/__webpack_require__.n(vue_material);

// EXTERNAL MODULE: ./node_modules/vue-material/dist/vue-material.min.css
var vue_material_min = __webpack_require__("4+hh");
var vue_material_min_default = /*#__PURE__*/__webpack_require__.n(vue_material_min);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var App = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69ebb215","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"pagina"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: App_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("HPt6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/vue-axios/dist/vue-axios.min.js
var vue_axios_min = __webpack_require__("Rf8U");
var vue_axios_min_default = /*#__PURE__*/__webpack_require__.n(vue_axios_min);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Shared/NotFound/NotFound.vue
//
//
//

/* harmony default export */ var NotFound = ({
  mounted: function mounted() {

    this.$router.push('/');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7e68c7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/NotFound/NotFound.vue
var NotFound_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var NotFound_staticRenderFns = []
var NotFound_esExports = { render: NotFound_render, staticRenderFns: NotFound_staticRenderFns }
/* harmony default export */ var NotFound_NotFound = (NotFound_esExports);
// CONCATENATED MODULE: ./src/components/Shared/NotFound/NotFound.vue
var NotFound_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var NotFound___vue_template_functional__ = false
/* styles */
var NotFound___vue_styles__ = null
/* scopeId */
var NotFound___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NotFound___vue_module_identifier__ = null
var NotFound_Component = NotFound_normalizeComponent(
  NotFound,
  NotFound_NotFound,
  NotFound___vue_template_functional__,
  NotFound___vue_styles__,
  NotFound___vue_scopeId__,
  NotFound___vue_module_identifier__
)

/* harmony default export */ var Shared_NotFound_NotFound = (NotFound_Component.exports);

// CONCATENATED MODULE: ./src/components/Usuario/Rotas/Routes.js
var Login = function Login() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(6)]).then(__webpack_require__.bind(null, "M5xg"));
};
var Notificacao = function Notificacao() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(8)]).then(__webpack_require__.bind(null, "4JxA"));
};
var Mudarsenha = function Mudarsenha() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(10)]).then(__webpack_require__.bind(null, "PTb2"));
};
var Layout = function Layout() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(__webpack_require__.bind(null, "kRxs"));
};

var UsuarioRoutes = [{ path: '', name: 'login', component: Login },
// {path: 'mudarsenha', name: 'mudarsenha', component: Mudarsenha,  meta: {auth: true}},
{ path: '/',
  component: Layout,
  children: [{ path: 'mudarsenha', name: 'mudarsenha', component: Mudarsenha, meta: { auth: true } }] }, {
  path: '/',
  component: Layout,
  children: [{ path: 'notificacao', name: 'notificacao', component: Notificacao, meta: { auth: true } }, { path: 'notificacao/:id', name: 'dados-notificacao', component: Notificacao, meta: { auth: true } }]
}];
// CONCATENATED MODULE: ./src/components/Home/Rotas/Routes.js
var Routes_Layout = function Layout() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(__webpack_require__.bind(null, "kRxs"));
};
var Home = function Home() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(9)]).then(__webpack_require__.bind(null, "ttfj"));
};

var HomeRoutes = [{ path: '/',
  component: Routes_Layout,
  children: [{ path: "home", component: Home, name: 'home', meta: { auth: true } }]
}];
// CONCATENATED MODULE: ./src/components/Financeiro/Rotas/Routes.js
var Rotas_Routes_Layout = function Layout() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(__webpack_require__.bind(null, "kRxs"));
};
var Financeiro = function Financeiro() {
  return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, "26bq"));
};
var ContaReceber = function ContaReceber() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(17)]).then(__webpack_require__.bind(null, "YUl2"));
};

var FinanceiroRoutes = [{
  path: '/',
  component: Rotas_Routes_Layout,
  children: [{ path: 'financeiro', component: Financeiro, name: 'financeiro', meta: { auth: true } }, { path: 'financeiro/cliente', component: ContaReceber, name: 'financeiro-cliente', meta: { auth: true } }, { path: 'financeiro/contareceber', component: ContaReceber, name: 'financeiro-conta-a-receber', meta: { auth: true } }]
}];
// CONCATENATED MODULE: ./src/components/Estoque/Rotas/Routes.js
var Estoque_Rotas_Routes_Layout = function Layout() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(__webpack_require__.bind(null, "kRxs"));
};
var Estoque = function Estoque() {
  return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, "Mf4P"));
};
var ConsultaEstoque = function ConsultaEstoque() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(14)]).then(__webpack_require__.bind(null, "7d9F"));
};

var EstoqueRoutes = [{
  path: '/',
  component: Estoque_Rotas_Routes_Layout,
  children: [{ path: 'estoque', component: Estoque, name: 'estoque', meta: { auth: true } }, { path: 'estoque/consultaestoque', component: ConsultaEstoque, name: 'estoque-consulta-estoque', meta: { auth: true } }, { path: 'estoque/consultaestoque/:id', component: ConsultaEstoque, name: 'estoque-dados-produto-estoque', meta: { auth: true } }]
}];
// CONCATENATED MODULE: ./src/components/Carrinho/Rotas/Routes.js
var Carrinho_Rotas_Routes_Layout = function Layout() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(__webpack_require__.bind(null, "kRxs"));
};
var Carrinho = function Carrinho() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(__webpack_require__.bind(null, "NGoa"));
};

var CarrinhoRoutes = [{
  path: '/',
  component: Carrinho_Rotas_Routes_Layout,
  children: [{ path: 'carrinho', component: Carrinho, name: 'carrinho', meta: { auth: true } }]
}];
// CONCATENATED MODULE: ./src/components/Cadastro/Rotas/Routes.js
var Cadastro_Rotas_Routes_Layout = function Layout() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(__webpack_require__.bind(null, "kRxs"));
};
var Cadastro = function Cadastro() {
  return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, "qtG/"));
};

var Produto = function Produto() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(5)]).then(__webpack_require__.bind(null, "7QPj"));
};
var ProdutoB2B = function ProdutoB2B() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(__webpack_require__.bind(null, "Z3lz"));
};
var DadosProduto = function DadosProduto() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(4)]).then(__webpack_require__.bind(null, "IR6i"));
};

var Grupo = function Grupo() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(16)]).then(__webpack_require__.bind(null, "sVlB"));
};
var Subgrupo = function Subgrupo() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(12)]).then(__webpack_require__.bind(null, "I6iJ"));
};
var Categoria = function Categoria() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(18)]).then(__webpack_require__.bind(null, "Euk+"));
};
var Marca = function Marca() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(13)]).then(__webpack_require__.bind(null, "TiEI"));
};

var Parceiro = function Parceiro() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(20)]).then(__webpack_require__.bind(null, "wX84"));
};
var DadosParceiro = function DadosParceiro() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(7)]).then(__webpack_require__.bind(null, "7aEC"));
};
var Diretriz = function Diretriz() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(11)]).then(__webpack_require__.bind(null, "qGOO"));
};

var CadastroRoutes = [{
  path: '/',
  component: Cadastro_Rotas_Routes_Layout,
  children: [{ path: 'cadastro', component: Cadastro, name: 'cadastro', meta: { auth: true } }, { path: 'cadastro/produto', component: Produto, name: 'cadastro-produto', meta: { auth: true } }, { path: 'produto', component: Produto, name: 'produto', meta: { auth: true } }, { path: 'produto/b2b', component: ProdutoB2B, alias: 'produto', name: 'produtob2b', meta: { auth: true } }, { path: 'produto/dados/:id', component: DadosProduto, name: 'dados-produto', meta: { auth: true, acao: 'consulta' } }, { path: 'produto/incluir', component: DadosProduto, name: 'cadastrar-produto', meta: { auth: true, acao: 'incluir' } }, { path: 'produto/alterar/:id', component: DadosProduto, name: 'alterar-produto', meta: { auth: true, acao: 'alterar' } }, { path: 'cadastro/grupo', component: Grupo, name: 'produto-grupo', meta: { auth: true } }, { path: 'cadastro/subgrupo', component: Subgrupo, name: 'produto-subgrupo', meta: { auth: true } }, { path: 'cadastro/categoria', component: Categoria, name: 'produto-categoria', meta: { auth: true } }, { path: 'cadastro/marca', component: Marca, name: 'produto-marca', meta: { auth: true } }, { path: 'parceiro', component: Parceiro, name: 'parceiro-b2b', meta: { auth: true } }, { path: 'cadastro/parceiro', component: Parceiro, name: 'parceiro', meta: { auth: true } }, { path: 'parceiro/dados/:id', component: DadosParceiro, name: 'dados-parceiro', meta: { auth: true, acao: 'consulta' } }, { path: 'parceiro/incluir', component: DadosParceiro, name: 'cadastrar-parceiro', meta: { auth: true, acao: 'incluir' } }, { path: 'parceiro/alterar/:id', component: DadosParceiro, name: 'alterar-parceiro', meta: { auth: true, acao: 'alterar' } }, { path: 'cadastro/diretriz', component: Diretriz, name: 'parceiro-diretiz', props: true, meta: { auth: true } }]
}];
// CONCATENATED MODULE: ./src/components/Venda/Rotas/Routes.js
var Venda_Rotas_Routes_Layout = function Layout() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(__webpack_require__.bind(null, "kRxs"));
};
var Venda = function Venda() {
  return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, "7+u+"));
};
var Pedido = function Pedido() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(19)]).then(__webpack_require__.bind(null, "17Wj"));
};
var DadosPedido = function DadosPedido() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(15)]).then(__webpack_require__.bind(null, "YLvb"));
};

var VendaRoutes = [{
  path: '/',
  component: Venda_Rotas_Routes_Layout,
  children: [{ path: 'venda', component: Venda, name: 'venda', meta: { auth: true } }, { path: 'venda/pedido', component: Pedido, name: 'venda-pedido', meta: { auth: true } }, { path: 'venda/pedido/dados/:id', component: DadosPedido, name: 'venda-dados-pedido', meta: { auth: true, acao: 'consulta' } }]
}];
// CONCATENATED MODULE: ./src/router/Routes.js









var routes = [{ path: '*', component: Shared_NotFound_NotFound }].concat(UsuarioRoutes, HomeRoutes, FinanceiroRoutes, EstoqueRoutes, CarrinhoRoutes, CadastroRoutes, VendaRoutes);

// for (let i = 0; i < UsuarioRoutes.length; i++) {
//   routes.push(UsuarioRoutes[i]);
// }
// for (let i = 0; i < HomeRoutes.length; i++) {
//   routes.push(HomeRoutes[i]);
// }
// for (let i = 0; i < FinanceiroRoutes.length; i++) {
//   routes.push(FinanceiroRoutes[i]);
// }
// for (let i = 0; i < EstoqueRoutes.length; i++) {
//   routes.push(EstoqueRoutes[i]);
// }
// for (let i = 0; i < CarrinhoRoutes.length; i++) {
//   routes.push(CarrinhoRoutes[i]);
// }
// for (let i = 0; i < CadastroRoutes.length; i++) {
//   routes.push(CadastroRoutes[i]);
// }
// for (let i = 0; i < VendaRoutes.length; i++) {
//   routes.push(VendaRoutes[i]);
// }
// EXTERNAL MODULE: ./node_modules/vee-validate/dist/locale/pt_BR.js
var pt_BR = __webpack_require__("RAMx");
var pt_BR_default = /*#__PURE__*/__webpack_require__.n(pt_BR);

// EXTERNAL MODULE: ./node_modules/vee-validate/dist/vee-validate.esm.js
var vee_validate_esm = __webpack_require__("sUu7");

// EXTERNAL MODULE: ./node_modules/vue2-filters/dist/vue2-filters.js
var vue2_filters = __webpack_require__("OjAt");
var vue2_filters_default = /*#__PURE__*/__webpack_require__.n(vue2_filters);

// CONCATENATED MODULE: ./src/vuex/modules/usuario.js
var state = {
  'usuario': ''
};

var getters = {
  usuario: function usuario(state) {
    return state.usuario;
  }
};

var mutations = {
  setUsuario: function setUsuario(state, value) {
    state.usuario = value;
  }
};

var actions = {
  setUsuario: function setUsuario(context, value) {
    context.commit('setUsuario', value);
  }
};

/* harmony default export */ var usuario = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});
// CONCATENATED MODULE: ./src/vuex/modules/parceiro.js
var parceiro_state = {
  parceiro: '',
  clientes: ''
};

var parceiro_getters = {
  parceiro: function parceiro(state) {
    return state.parceiro;
  },
  parceiroClientes: function parceiroClientes(state) {
    return state.clientes;
  }
};

var parceiro_mutations = {
  setParceiro: function setParceiro(state, value) {
    state.parceiro = value;
  },
  setParceiroClientes: function setParceiroClientes(state, value) {
    state.clientes = value;
  }
};

var parceiro_actions = {
  setParceiro: function setParceiro(context, value) {
    context.commit('setParceiro', value);
  },
  setParceiroClientes: function setParceiroClientes(context, value) {
    context.commit('setParceiroClientes', value);
  }
};

/* harmony default export */ var parceiro = ({
  state: parceiro_state,
  getters: parceiro_getters,
  mutations: parceiro_mutations,
  actions: parceiro_actions
});
// CONCATENATED MODULE: ./src/vuex/modules/notificacao.js
var notificacao_state = {
  notificacao: ''
};

var notificacao_getters = {
  notificacao: function notificacao(state) {
    return state.notificacao;
  }
};

var notificacao_mutations = {
  setNotificacao: function setNotificacao(state, value) {
    state.notificacao = value;
  }
};

var notificacao_actions = {
  setNotificacao: function setNotificacao(context, value) {
    context.commit('setNotificacao', value);
  }
};

/* harmony default export */ var notificacao = ({
  state: notificacao_state,
  getters: notificacao_getters,
  mutations: notificacao_mutations,
  actions: notificacao_actions
});
// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./src/vuex/store.js




/* Vueex */


vue_esm["default"].use(vuex_esm["a" /* default */]);

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  modules: {
    usuario: usuario,
    parceiro: parceiro,
    notificacao: notificacao
  }
}));
// EXTERNAL MODULE: ./node_modules/es6-promise/auto.js
var auto = __webpack_require__("MU8w");
var auto_default = /*#__PURE__*/__webpack_require__.n(auto);

// EXTERNAL MODULE: ./node_modules/sweetalert/dist/sweetalert.min.js
var sweetalert_min = __webpack_require__("thjQ");
var sweetalert_min_default = /*#__PURE__*/__webpack_require__.n(sweetalert_min);

// EXTERNAL MODULE: ./static/css/swal.css
var swal = __webpack_require__("eXN7");
var swal_default = /*#__PURE__*/__webpack_require__.n(swal);

// EXTERNAL MODULE: ./src/helpers/Formulario/Formulario.js
var Formulario = __webpack_require__("/69k");

// EXTERNAL MODULE: ./node_modules/vue-the-mask/dist/vue-the-mask.js
var vue_the_mask = __webpack_require__("hlPV");
var vue_the_mask_default = /*#__PURE__*/__webpack_require__.n(vue_the_mask);

// EXTERNAL MODULE: ./src/helpers/Storage/Storage.js
var Storage = __webpack_require__("euKi");

// EXTERNAL MODULE: ./node_modules/ag-grid/dist/styles/ag-grid.css
var ag_grid = __webpack_require__("L773");
var ag_grid_default = /*#__PURE__*/__webpack_require__.n(ag_grid);

// EXTERNAL MODULE: ./node_modules/ag-grid/dist/styles/ag-theme-material.css
var ag_theme_material = __webpack_require__("hgLm");
var ag_theme_material_default = /*#__PURE__*/__webpack_require__.n(ag_theme_material);

// EXTERNAL MODULE: ./node_modules/ag-grid-enterprise/main.js
var main = __webpack_require__("iMcQ");
var main_default = /*#__PURE__*/__webpack_require__.n(main);

// EXTERNAL MODULE: ./node_modules/vue-snotify/vue-snotify.esm.js
var vue_snotify_esm = __webpack_require__("HgYs");

// EXTERNAL MODULE: ./node_modules/vue-snotify/styles/material.css
var material = __webpack_require__("2d5O");
var material_default = /*#__PURE__*/__webpack_require__.n(material);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// CONCATENATED MODULE: ./src/components/Shared/Material/MaterialSelect.js



// O <span class="caret"> que o Materialize desenha fica por cima do lado
// direito do campo, mas NAO e o elemento onde o plugin dropdown registra o
// clique (esse e o <input class="select-dropdown">). Sem este delegate, clicar
// exatamente na setinha nao abre nada.
//
// Delegate global registrado uma unica vez para nao empilhar handler a cada
// mount de um material-select.
$(function () {
  $(document).off('mousedown.materialSelectCaret').off('click.materialSelectCaret')
  // Dentro de um modal o campo abria no focus e fechava logo em seguida no
  // blur, no mesmo clique: algo devolvia o foco para o modal e o Materialize
  // fecha o dropdown no blur. O preventDefault no mousedown impede a troca
  // de foco, e a abertura passa a ser feita explicitamente no click abaixo.
  // Vale para a setinha e para o proprio campo.
  .on('mousedown.materialSelectCaret', '.select-wrapper span.caret, .select-wrapper input.select-dropdown', function (e) {
    e.preventDefault();
  }).on('click.materialSelectCaret', '.select-wrapper span.caret, .select-wrapper input.select-dropdown', function (e) {

    e.preventDefault();
    e.stopPropagation();

    var $alvo = $(this);
    var $input = $alvo.is('input.select-dropdown') ? $alvo : $alvo.siblings('input.select-dropdown');

    if (!$input.length || $input.is(':disabled')) {
      return;
    }

    // placeDropdown/hideDropdown do Materialize mantem a classe 'active' no
    // origin, entao ela e a fonte de verdade de "esta aberto".
    if ($input.hasClass('active')) {
      $input.trigger('close');
      return;
    }

    // Abre pelo mesmo evento que o handler de focus do Materialize usa.
    // O parametro 'focus' faz o plugin marcar isFocused, evitando que o
    // proprio handler de click dele trate isso como um toggle e feche.
    $input.trigger('open', ['focus']);
  });
});

vue_esm["default"].component("material-select", {
  name: 'material-select',
  template: '<select><slot></slot></select>',
  props: ['value'],
  watch: {
    value: function value(_value) {

      // Trocar o valor nao precisa reconstruir o widget: basta sincronizar o
      // rotulo e o <li> ativo.
      this.syncValue(_value);
    }
  },
  methods: {

    // Assinatura das <option> atuais. Serve para detectar se o update do Vue
    // realmente mexeu na lista ou se foi so um re-render do pai.
    optionsSignature: function optionsSignature() {

      var sig = [];

      $(this.$el).find('option').each(function () {
        sig.push([this.value, this.text, this.disabled]);
      });

      return stringify_default()(sig);
    },

    syncValue: function syncValue(value) {

      var $select = $(this.$el);
      var v = value === undefined ? this.value : value;

      $select.val(v === null || v === undefined ? '' : v);

      var el = $select[0];
      var $wrapper = $select.closest('.select-wrapper');
      var $input = $wrapper.find('input.select-dropdown');

      if (!$input.length) {
        return;
      }

      var index = el.selectedIndex;

      $input.val(index >= 0 ? $(el.options[index]).text() : '');

      // O Materialize indexa os <li> ignorando os de optgroup.
      var $itens = $wrapper.find('ul.select-dropdown > li:not(.optgroup)');

      $itens.removeClass('active');

      if (index >= 0) {
        $itens.eq(index).addClass('active');
      }
    },

    rebuild: function rebuild() {

      var $select = $(this.$el);
      var v = this.value;

      // O Materialize monta o rotulo a partir de option:selected, entao o
      // valor precisa estar aplicado antes de reconstruir.
      $select.val(v === null || v === undefined ? '' : v);

      $select.material_select('destroy');
      $select.material_select();

      // O Materialize so marca o <li> com a classe 'active' no clique, entao
      // apos reconstruir a lista abriria sem realcar a opcao ja selecionada.
      this.syncValue();

      this._lastSignature = this.optionsSignature();
    }
  },
  mounted: function mounted() {

    var vm = this;
    var $select = $(this.$el);

    $select.val(this.value).on('change', function () {

      vm.$emit('input', this.value);

      // O Materialize fechava a lista no blur do input. Como agora impedimos
      // a troca de foco (para o dropdown nao fechar sozinho ao abrir), esse
      // blur nao acontece mais e a lista ficava aberta apos escolher uma
      // opcao, dando a impressao de que nada tinha sido selecionado.
      if (!this.multiple) {
        $(this).closest('.select-wrapper').find('input.select-dropdown').trigger('close');
      }
    });

    $select.material_select();

    this.syncValue();

    this._lastSignature = this.optionsSignature();
  },
  updated: function updated() {

    // material_select('destroy') + material_select() remonta o widget inteiro
    // e descarta o <ul> aberto. Rodar isso a cada updated() fazia o dropdown
    // sumir embaixo do cursor sempre que qualquer dado reativo da tela mudava
    // (chegada de options por AJAX, spinner, total recalculado), obrigando o
    // usuario a clicar de novo. So reconstroi quando a lista mudou de fato.
    if (this.optionsSignature() === this._lastSignature) {
      this.syncValue();
      return;
    }

    this.rebuild();
  },
  destroyed: function destroyed() {

    $(this.$el).material_select('destroy');
  }
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/vue-multiselect/dist/vue-multiselect.min.js
var vue_multiselect_min = __webpack_require__("RUzx");
var vue_multiselect_min_default = /*#__PURE__*/__webpack_require__.n(vue_multiselect_min);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Shared/Material/MaterialCombo.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MaterialCombo = ({
  name: 'material-combo',
  components: { Multiselect: vue_multiselect_min_default.a },
  props: {
    value: { type: [String, Number, null], default: '' },
    options: { type: Array, default: function _default() {
        return [];
      } },
    // Aceita um kendo.data.DataSource diretamente — o wrapper sincroniza
    // os dados via bind('change'), evitando refactor no controller.
    dataSource: { type: Object, default: null },
    textField: { type: String, required: true },
    valueField: { type: String, default: 'id' },
    placeholder: { type: String, default: 'Selecione' },
    searchable: { type: Boolean, default: true },
    allowEmpty: { type: Boolean, default: true },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      dsOptions: []
    };
  },

  computed: {
    effectiveOptions: function effectiveOptions() {
      if (this.dataSource && typeof this.dataSource.data === 'function') {
        return this.dsOptions;
      }
      return this.options;
    },
    selectedOption: function selectedOption() {
      var _this = this;

      var v = this.value;
      if (v === '' || v === null || v === undefined) return null;
      return this.effectiveOptions.find(function (o) {
        return String(o[_this.valueField]) === String(v);
      }) || null;
    }
  },
  methods: {
    onInput: function onInput(opt) {
      var newVal = opt ? opt[this.valueField] : '';
      this.$emit('input', newVal != null ? String(newVal) : '');
      this.$emit('change', opt || null);
    },
    syncFromDataSource: function syncFromDataSource() {
      if (this.dataSource && typeof this.dataSource.data === 'function') {
        this.dsOptions = this.dataSource.data().toJSON ? this.dataSource.data().toJSON() : [].concat(toConsumableArray_default()(this.dataSource.data()));
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.dataSource && typeof this.dataSource.bind === 'function') {
      this.syncFromDataSource();
      this._dsChangeHandler = function () {
        return _this2.syncFromDataSource();
      };
      this.dataSource.bind('change', this._dsChangeHandler);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.dataSource && this._dsChangeHandler && typeof this.dataSource.unbind === 'function') {
      this.dataSource.unbind('change', this._dsChangeHandler);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e1f3859","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/Material/MaterialCombo.vue
var MaterialCombo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('multiselect',{attrs:{"value":_vm.selectedOption,"options":_vm.effectiveOptions,"label":_vm.textField,"track-by":_vm.valueField,"placeholder":_vm.placeholder,"searchable":_vm.searchable,"allow-empty":_vm.allowEmpty,"show-labels":false,"loading":_vm.loading,"disabled":_vm.disabled,"select-label":"","selected-label":"","deselect-label":""},on:{"input":_vm.onInput}},[_c('template',{slot:"noResult"},[_vm._v("Nenhum resultado encontrado.")]),_vm._v(" "),_c('template',{slot:"noOptions"},[_vm._v("Lista vazia.")])],2)}
var MaterialCombo_staticRenderFns = []
var MaterialCombo_esExports = { render: MaterialCombo_render, staticRenderFns: MaterialCombo_staticRenderFns }
/* harmony default export */ var Material_MaterialCombo = (MaterialCombo_esExports);
// CONCATENATED MODULE: ./src/components/Shared/Material/MaterialCombo.vue
function MaterialCombo_injectStyle (ssrContext) {
  __webpack_require__("lIFm")
}
var MaterialCombo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MaterialCombo___vue_template_functional__ = false
/* styles */
var MaterialCombo___vue_styles__ = MaterialCombo_injectStyle
/* scopeId */
var MaterialCombo___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MaterialCombo___vue_module_identifier__ = null
var MaterialCombo_Component = MaterialCombo_normalizeComponent(
  MaterialCombo,
  Material_MaterialCombo,
  MaterialCombo___vue_template_functional__,
  MaterialCombo___vue_styles__,
  MaterialCombo___vue_scopeId__,
  MaterialCombo___vue_module_identifier__
)

/* harmony default export */ var Shared_Material_MaterialCombo = (MaterialCombo_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-multiselect/dist/vue-multiselect.min.css
var dist_vue_multiselect_min = __webpack_require__("tLvy");
var dist_vue_multiselect_min_default = /*#__PURE__*/__webpack_require__.n(dist_vue_multiselect_min);

// EXTERNAL MODULE: ./node_modules/@progress/kendo-ui/js/kendo.all.js
var kendo_all = __webpack_require__("nb/C");
var kendo_all_default = /*#__PURE__*/__webpack_require__.n(kendo_all);

// EXTERNAL MODULE: ./static/css/kendo/all-blue.css
var all_blue = __webpack_require__("t/f6");
var all_blue_default = /*#__PURE__*/__webpack_require__.n(all_blue);

// EXTERNAL MODULE: ./node_modules/@progress/kendo-dropdowns-vue-wrapper/dist/es/index.js
var es = __webpack_require__("G5x9");
var es_default = /*#__PURE__*/__webpack_require__.n(es);

// CONCATENATED MODULE: ./src/main.js


















vue_esm["default"].use(vue_material_default.a);

/* FUNÇÃO PARA FECHAR MODAL NA FRENTE DO OUTRO */

Object(Formulario["b" /* fecharModal */])();

/* Vue Mask Input */

vue_esm["default"].use(vue_the_mask_default.a);

/* VeeValidator */
vue_esm["default"].use(vee_validate_esm["b" /* default */]);
vee_validate_esm["a" /* Validator */].localize('pt_BR', pt_BR_default.a);

/* DEBUG VUEJS */
vue_esm["default"].config.productionTip = false;
vue_esm["default"].config.devtools = true;
vue_esm["default"].config.performance = true;

/* VueAxios */
vue_esm["default"].use(vue_axios_min_default.a, axios_default.a);

vue_esm["default"].filter('integer', function (value) {
    if (!value) return '';
    return Math.floor(value); // Exemplo: arredonda para o número inteiro
});

var dominio = window.location.host;

if (dominio === "localhost:8090" || dominio === "fcserver.fabricadecodigos.com.br:8091") {

    // axios.defaults.headers['Subdomain'] = 'dev';
    // Vue.axios.defaults.baseURL = 'http://www.api.com.br/index.php/';
    axios_default.a.defaults.headers['Subdomain'] = 'dev';
    vue_esm["default"].axios.defaults.baseURL = 'http://fcserver.fabricadecodigos.com.br:8097/';
    //   Vue.axios.defaults.baseURL = 'https://ordesign.websysemp.com.br/api/';
} else {
    var subdominio = dominio.split('.');
    axios_default.a.defaults.headers['Subdomain'] = subdominio[0];

    // LINK DE PRODUÇÃO
    vue_esm["default"].axios.defaults.baseURL = window.location.protocol + '//' + subdominio[0] + '.websysemp.com.br/api/';

    // CONFIGURAÇÃO E LINK DE TESTE PARA O FCSERVER
    //    axios.defaults.headers['Subdomain'] = 'dev';
    //    Vue.axios.defaults.baseURL = 'http://fcserver.fabricadecodigos.com.br:8080/';
}

/* VueRouter */
vue_esm["default"].use(vue_router_esm["a" /* default */]);
var router = new vue_router_esm["a" /* default */]({
    routes: routes,
    mode: 'history'
});

/* Vue2Filters */
vue_esm["default"].use(vue2_filters_default.a);

/* checkCookie Usuario e Parceiro */


router.beforeEach(function (to, from, next) {

    /* Limpa mensagem de alerta que fica instanciado (Snotify)  */
    vue_esm["default"].prototype.$snotify.clear();

    var validaSessao = false;
    if (Object(Storage["a" /* CheckLocalStorage */])('Parceiro')) {
        validaSessao = true;
    }
    if (Object(Storage["a" /* CheckLocalStorage */])('Usuario')) {
        validaSessao = true;
    }

    if (to.matched.some(function (record) {
        return record.meta.auth;
    }) && validaSessao === false) {
        next({ path: '/' });
    }
    next();
});

/* AGGRID VUEJS */




/* SET VALIDAÇÃO USUARIO OU PARCEIRO
 * Campo Tipo Usuario no JSON Valida o tipo de Usuario
 * Usuario SysEmp = 1
 * Usuario B2B = 2
 * */
var validaUsuario = '';
if (Object(Storage["a" /* CheckLocalStorage */])('Usuario')) {
    validaUsuario = Object(Storage["b" /* GetLocalStorage */])('Usuario');
} else {
    validaUsuario = Object(Storage["b" /* GetLocalStorage */])('Parceiro');
}
vue_esm["default"].prototype.validaUsuario = validaUsuario;

/* SNOTIFY */

vue_esm["default"].use(vue_snotify_esm["a" /* default */], {});


/* SelectMaterial */


/* MaterialCombo (substitui kendo-combobox com busca) */


vue_esm["default"].component('material-combo', Shared_Material_MaterialCombo);

/* VUE - KENDO UI - TELERIK */




vue_esm["default"].use(es["KendoDropdownsInstaller"]);

var app = new vue_esm["default"]({
    el: '#app',
    router: router,
    store: store,
    render: function render(h) {
        return h(src_App);
    }
});

/* harmony default export */ var src_main = __webpack_exports__["default"] = (app);

/***/ }),

/***/ "eXN7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "euKi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SetSessionStorage */
/* unused harmony export GetSessionStorage */
/* unused harmony export CheckSessionStorage */
/* unused harmony export RemoverSessionStorage */
/* harmony export (immutable) */ __webpack_exports__["d"] = SetLocalStorage;
/* harmony export (immutable) */ __webpack_exports__["b"] = GetLocalStorage;
/* harmony export (immutable) */ __webpack_exports__["a"] = CheckLocalStorage;
/* harmony export (immutable) */ __webpack_exports__["c"] = RemoverLocalStorage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

function SetSessionStorage(nome, dados) {
  sessionStorage.setItem(nome, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(dados));
}

function GetSessionStorage(nome) {
  return JSON.parse(sessionStorage.getItem(nome));
}

function CheckSessionStorage(nome) {

  if (sessionStorage.getItem(nome) == null || typeof sessionStorage.getItem(nome) === 'undefined') {
    return false;
  } else {
    return true;
  }
}

function RemoverSessionStorage(nome) {
  sessionStorage.removeItem(nome);
}

/* LocalStorage */

function SetLocalStorage(nome, dados) {
  localStorage.setItem(nome, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(dados));
}

function GetLocalStorage(nome) {
  return JSON.parse(localStorage.getItem(nome));
}

function CheckLocalStorage(nome) {

  if (localStorage.getItem(nome) == null || typeof localStorage.getItem(nome) === 'undefined') {
    return false;
  } else {
    return true;
  }
}

function RemoverLocalStorage(nome) {
  localStorage.removeItem(nome);
}

/***/ }),

/***/ "hgLm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lIFm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t/f6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tLvy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.ee1b0fcdfea71844f753.js